import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { FileToUpload } from "../../models/filetoupload";
import { empty } from "rxjs";
import { isEmpty } from "rxjs/Operators";
import { FileUploadService } from "../../service/fileUpload.service";
import { OnboardHREmpDoc } from "../../models/OnboardHREmpDoc";
import { FormControl } from "@angular/forms";
import { isNullOrUndefined } from "util";
import { File_Types } from "../../UploadFileTypes";
import { EmployeeService } from "../../service/employee.service";

@Component({
  selector: "app-multiple-files-dialog",
  templateUrl: "./multiple-files-dialog.component.html",
  styleUrls: ["./multiple-files-dialog.component.css"],
})
export class MultipleFilesDialogComponent implements OnInit {
  title: string;
  DialogTitle: string;
  message: any;
  screenName: string;
  empCode:number
  MAX_SIZE: number = 1048576;
  MulfilesArray: OnboardHREmpDoc[] = [];
  newAttribute: OnboardHREmpDoc;
  defaultDocumentList: any[] = [];
  docType: any;
  count: number;
  index: number = 0;
  type: string;
  constructor(
    private toastr: ToastrService,
    public fileService: FileUploadService,
    private empsvc: EmployeeService,
    public dialogRef: MatDialogRef<MultipleFilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultipleFilesDialog
  ) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.screenName = data.screenName;
    this.empCode = data.empCode;
    this.count = data.count;
    this.type = data.type
    if (data.screenName == "EducationTab") {
      this.DialogTitle = "Qualification";
      this.docType = "Testimonial"
      this.message = data.message.Qualification;
    } else if (data.screenName == "PrevEmpTab") {
      this.DialogTitle = "Previous Company";
      this.docType = "PreviousCompany"
      this.message = data.message.CompanyName;
    } else if (data.screenName == "AdditionalDocuments") {
      this.docType = "AdditionalDoc"
      this.DialogTitle = "Qualification";
      this.message = data.message;
    }
  }

  ngOnInit() {
    //this.fileNameControl = new FormControl();
    //this.fileControl = new FormControl();
    this.getDefaultDocumentList()
    this.newAttribute = new OnboardHREmpDoc();
    this.addRow(0);
     ;
  }

  getDefaultDocumentList() {
    this.empsvc.GetMasterPreviousEmpDoc().subscribe((data: any) => {
      this.defaultDocumentList = data;
    });
  }

  addRow(ind) {
    if (this.data.screenName !== "PrevEmpTab" && ind == 0)
      this.newAttribute.DocNumber = this.type == "app-hr-employee-details" ? this.empCode + "_" + this.docType + "_" + this.count : this.docType + "_" + this.count;
    else if (this.data.screenName !== "PrevEmpTab" && ind == 1) {
      this.index += 1;
      this.newAttribute.DocNumber = this.type == "app-hr-employee-details" ? this.empCode + "_" + this.docType + "_" + (this.count + this.index) : this.docType + "_" + (this.count + this.index);
    }
    this.MulfilesArray.push(this.newAttribute);
    this.newAttribute = new OnboardHREmpDoc();
  }
  deleteField(index) {
    this.MulfilesArray.splice(index, 1);
  }
  handleFile(event, index) {
     ;
    if (event.target.files == undefined) {
      this.MulfilesArray[index].File = null;
    }
    const files: FileList = event.target.files;
    let fil: FileList;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.MulfilesArray[index].File =
          this.fileService.readAndUploadFile(files);
        this.MulfilesArray[index].EmpId = this.data.empCode;
      } else {
        this.toastr.warning(
          " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }
  //check the file types
  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }

  //returns true if given string is empty or had spaces
  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  onConfirm(): void {
    if (this.MulfilesArray.length > 0) {
      for (var i = 0; i < this.MulfilesArray.length; i++) {
        if (
          isNullOrUndefined(this.MulfilesArray[i].DocNumber) ||
          isNullOrUndefined(this.MulfilesArray[i].File)
        ) {
          this.toastr.warning("Please fill in the required fields");
          return;
        } else if (this.isEmptyOrSpaces(this.MulfilesArray[i].DocNumber)) {
          this.toastr.warning("Please enter valid File name");
          return;
        }
      }
      this.dialogRef.close(this.MulfilesArray);
    }
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
export class MultipleFilesDialog {
  constructor(
    public title: string,
    public message: any,
    public screenName: string,
    public empCode: number,
    public count: number,
    public type: string,
  ) {}
}
